import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import ComingSoonModal from './components/feature/ComingSoonModal'

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <ComingSoonModal />
    </BrowserRouter>
  )
}

export default App